/* eslint-disable import/first */
import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { useNavigate } from '@reach/router';
import { FormattedMessage } from 'react-intl';
import css from './index.module.scss';
import ClassNames from 'classnames';

const Footer = () => {
  const navigate = useNavigate();
  return (
    <Grid className={ClassNames(css.footerContainer, css.termsCondition)}>
      <Grid onClick={() => navigate('/terms')}>
        <Typography className={css.terms}>
          <FormattedMessage id="terms&Conditions" defaultMessage="TERMS & CONDITIONS" />
        </Typography>
      </Grid>
      <Grid onClick={() => navigate('/home')}>
        <Typography className={css.skipLogin}>
          <FormattedMessage id="skipLoginContinue" defaultMessage="SKIP LOGIN & CONTINUE" />
        </Typography>
        <Typography></Typography>
      </Grid>
    </Grid>
  );
};

export default Footer;
